export default __webpack_public_path__ + "static/media/box8.97e4c212.jpg";